import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const SheetFieldInstanceDatasourceFragmentGql: DocumentNode = gql`
fragment SheetFieldInstanceDatasourceFragment on Datasource {
  __typename
  id
  name
  hasExtracts
  extractLastUpdateTime
  ... on PublishedDatasource {
    vizportalUrlId
    isCertified
  }
}
`;
